function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/speed-master");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "3.515625e-05 6.95652174e-05 45 6.95652174e-05 45 48 3.515625e-05 48"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "3.515625e-05 6.95652174e-05 45 6.95652174e-05 45 44.5218087 3.515625e-05 44.5218087"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-217.000000, -393.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/speed-master",
  transform: "translate(217.000000, 393.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7812852,48.0000696 L4.21878516,48.0000696 C1.88898047,48.0000696 3.515625e-05,46.1312 3.515625e-05,43.8261565 L3.515625e-05,4.17398261 C3.515625e-05,1.86893913 1.88898047,6.95652174e-05 4.21878516,6.95652174e-05 L40.7812852,6.95652174e-05 C43.1110898,6.95652174e-05 45.0000352,1.86893913 45.0000352,4.17398261 L45.0000352,43.8261565 C45.0000352,46.1312 43.1110898,48.0000696 40.7812852,48.0000696",
  id: "Fill-1",
  fill: "#A3084F",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7812852,44.5218087 L4.21878516,44.5218087 C1.88898047,44.5218087 3.515625e-05,42.6529391 3.515625e-05,40.3478957 L3.515625e-05,4.17398261 C3.515625e-05,1.86893913 1.88898047,6.95652174e-05 4.21878516,6.95652174e-05 L40.7812852,6.95652174e-05 C43.1110898,6.95652174e-05 45.0000352,1.86893913 45.0000352,4.17398261 L45.0000352,40.3478957 C45.0000352,42.6529391 43.1110898,44.5218087 40.7812852,44.5218087",
  id: "Fill-4",
  fill: "#E80F62",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.9776719,11.6031652 L15.9776719,24.8803826 C15.9776719,25.2643826 16.2926719,25.5760348 16.6807969,25.5760348 L19.3178672,25.5760348 C19.7063438,25.5760348 20.0209922,25.8873391 20.0209922,26.271687 L20.0209922,35.0042087 C20.0209922,35.7144696 20.9698594,35.9680348 21.3316172,35.3548174 L28.8392344,22.6216 C29.1123984,22.1579478 28.7745469,21.5753391 28.2317344,21.5753391 L25.2023203,21.5753391 C24.6795469,21.5753391 24.3395859,21.0313391 24.573375,20.5687304 L28.9471641,11.9144696 C29.1809531,11.451513 28.8409922,10.907513 28.3182188,10.907513 L16.6807969,10.907513 C16.2926719,10.907513 15.9776719,11.2191652 15.9776719,11.6031652",
  id: "Fill-7",
  fill: "#FFDC4A"
})))));

var SvgSpeedMaster = function SvgSpeedMaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeedMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speed-master.9df63094.svg";
export { ForwardRef as ReactComponent };